"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _SDKClient_instances, _SDKClient_apiClient, _SDKClient_authClient, _SDKClient_authListeners, _SDKClient_refreshToken, _SDKClient_refreshAccessTokenMiddleware, _SDKClient_fetchApplicationAgreements, _SDKClient_getBaseUrl, _SDKClient_getBasePathForUserState, _SDKClient_getURLSearchParams;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKNotification = exports.SDKEvent = exports.SDKClient = exports.CHQ_SDK_ID = void 0;
const products_1 = require("@cardlesshq/web-api-client/src/types/products");
const user_1 = require("@cardlesshq/web-api-client/src/types/user");
const agreements_1 = require("@cardlesshq/web-api-client/src/types/agreements");
const constants_1 = require("./constants");
const package_json_1 = __importDefault(require("../package.json"));
const applications_1 = require("@cardlesshq/web-api-client/src/types/applications");
var SDKEvent;
(function (SDKEvent) {
    /** User applied for credit card and decisioning outcome was reached */
    SDKEvent["ApplyOutcome"] = "APPLY_OUTCOME";
    /** Cardless webapp is in a loading state */
    SDKEvent["FlowLoading"] = "FLOW_LOADING";
    /** Cardless webapp opened; e.g. embedded ad opened by partner window */
    SDKEvent["FlowOpened"] = "FLOW_OPENED";
    /** An outcome was reached in the flow; e.g. user successfully submitted a dispute */
    SDKEvent["FlowOutcome"] = "FLOW_OUTCOME";
    /** Cardless webapp ready to accept messages */
    SDKEvent["FlowReady"] = "FLOW_READY";
    /** Cardless user flow errored out */
    SDKEvent["Error"] = "ERROR";
    /** Cardless user flow exited */
    SDKEvent["Exit"] = "EXIT";
    /**
     * Called from embedded cardless content during
     * initialization (apply flow, ecad render, etc)
     */
    SDKEvent["InitializeEmbedded"] = "INITIALIZE_EMBEDDED";
    /**
     * Cardless webapp should be opened;
     * e.g. for an embedded ad & partner window should cal `window.open()`
     */
    SDKEvent["OpenFlow"] = "OPEN_FLOW";
    /** Payment auth code successfully requested, generated, and ready for use */
    SDKEvent["PaymentAuthCodeReady"] = "PAYMENT_AUTH_CODE_READY";
    /** Activity status ping; used to indicate app is still alive */
    SDKEvent["Ping"] = "PING";
    /** SDK ready to accept messages */
    SDKEvent["Ready"] = "READY";
    /** Cardless user flow transitioned from one screen to another */
    SDKEvent["TransitionView"] = "TRANSITION_VIEW";
    /** Pass-along Cardless UI width/height */
    SDKEvent["UIDimensions"] = "UI_DIMENSIONS";
})(SDKEvent || (exports.SDKEvent = SDKEvent = {}));
const LOG_TAG = '[sdk]';
class SDKNotification {
    constructor({ eventName, kid, metadata }) {
        this.eventName = eventName;
        this.kid = kid;
        this.metadata = metadata;
    }
}
exports.SDKNotification = SDKNotification;
const CHQ_SDK_ID = 'chq-sdk';
exports.CHQ_SDK_ID = CHQ_SDK_ID;
class SDKClient {
    constructor(_a) {
        var _b;
        var { apiClient, authClient, env = (_b = process.env.CONFIG_ENV) !== null && _b !== void 0 ? _b : 'staging', isStandalone, } = _a;
        _SDKClient_instances.add(this);
        _SDKClient_apiClient.set(this, void 0);
        _SDKClient_authClient.set(this, void 0);
        _SDKClient_authListeners.set(this, void 0);
        _SDKClient_refreshToken.set(this, void 0);
        const version = package_json_1.default.version;
        this.version = version;
        __classPrivateFieldSet(this, _SDKClient_authClient, authClient, "f");
        __classPrivateFieldSet(this, _SDKClient_apiClient, apiClient, "f");
        __classPrivateFieldGet(this, _SDKClient_apiClient, "f").setRefreshAccessTokenMiddleware(__classPrivateFieldGet(this, _SDKClient_instances, "m", _SDKClient_refreshAccessTokenMiddleware).bind(this));
        __classPrivateFieldSet(this, _SDKClient_authListeners, [], "f");
        this.env = env;
        if (
        // e.g. loaded via bridge, not code that is imported as dependency in webapp
        !isStandalone &&
            process.env.CYPRESS_IS_RUNNING !== 'true') {
            import('@datadog/browser-rum').then(({ datadogRum }) => {
                datadogRum.init({
                    applicationId: 'f20a9244-cb93-4229-bafd-33a17e93b44a',
                    clientToken: 'pub8188bdacbd8e9faef4570bcd36c6fbcb',
                    site: 'datadoghq.com',
                    service: 'sdk-javascript',
                    env,
                    version,
                    sessionSampleRate: 25,
                    sessionReplaySampleRate: 0,
                    trackUserInteractions: false,
                    trackResources: true,
                    trackLongTasks: true,
                    defaultPrivacyLevel: 'mask',
                });
            });
        }
    }
    /**
     * Send notification to Cardless SDK
     */
    notify(_a) {
        return __awaiter(this, arguments, void 0, function* ({ notification }) {
            var _b, _c;
            if (!notification) {
                throw new Error('notify invariant violation: expected to find notification in SDKData, but found none');
            }
            (_c = (_b = self === null || self === void 0 ? void 0 : self.CardlessSDK) === null || _b === void 0 ? void 0 : _b.notify) === null || _c === void 0 ? void 0 : _c.call(_b, typeof notification === 'string'
                ? notification
                : JSON.stringify(notification));
            return notification;
        });
    }
    /**
     * Instruct Cardless SDK to close webview or similar
     */
    exit(_data) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            console.log(LOG_TAG, 'exit');
            (_a = self === null || self === void 0 ? void 0 : self.CardlessSDK) === null || _a === void 0 ? void 0 : _a.exit();
        });
    }
    /**
     * Send authentication credentials from SDK to webapp
     */
    authenticate(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (data.accessToken) {
                // pass along accessToken to apiClient
                __classPrivateFieldGet(this, _SDKClient_apiClient, "f").setAccessToken(data.accessToken);
            }
            if (data.refreshToken) {
                __classPrivateFieldSet(this, _SDKClient_refreshToken, data.refreshToken, "f");
            }
            // await webview callback(s)
            const promises = __classPrivateFieldGet(this, _SDKClient_authListeners, "f").map((l) => l(data));
            yield Promise.all(promises);
            // all webview callback(s) resolved; success!
            return {
                authenticated: true,
            };
        });
    }
    /**
     * Generate information required to run apply flow
     */
    fetchApplyContext(data) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const { brandSlug, campaignSlug, productSlug, sessionId = '' } = data;
            try {
                const agreements = yield __classPrivateFieldGet(this, _SDKClient_instances, "m", _SDKClient_fetchApplicationAgreements).call(this, data);
                let pmvPresponse;
                if (brandSlug) {
                    pmvPresponse = yield __classPrivateFieldGet(this, _SDKClient_apiClient, "f").getProductMarketingVariantByBrand({
                        anonymousUuid: sessionId,
                        brandSlug,
                        productSlug,
                        utmTags: {
                            campaign: campaignSlug,
                        },
                    });
                }
                else if (productSlug) {
                    pmvPresponse = yield __classPrivateFieldGet(this, _SDKClient_apiClient, "f").getProductMarketingVariant({
                        anonymousUuid: sessionId,
                        productSlug,
                        utmTags: {
                            campaign: campaignSlug,
                        },
                    });
                }
                else {
                    pmvPresponse = {
                        campaignUuid: '',
                        cohortUuid: '',
                        applyFlowVariation: applications_1.ApplyFlowVariation.APPLY_FLOW_VARIATION_UNSPECIFIED,
                        variants: [],
                        slots: {
                            title: '',
                            subtitle: '',
                            termsHtml: '',
                            expirationDate: '',
                            callouts: [],
                        },
                        cardInfoAfterApproval: false,
                        paymentTokenIntegration: false,
                        requiresEncodedPartnerUserData: false,
                        productSlug: '',
                        skipMfa: false,
                    };
                }
                const { campaignUuid = '', slots, utmCampaign } = pmvPresponse;
                const metadataRaw = data === null || data === void 0 ? void 0 : data.metadata;
                let checkoutCost;
                try {
                    if (typeof metadataRaw === 'string') {
                        const { checkoutCost: checkoutCostRaw } = (_a = JSON.parse(metadataRaw)) !== null && _a !== void 0 ? _a : {
                            checkoutCost: undefined,
                        };
                        if (!!checkoutCostRaw && typeof checkoutCostRaw == 'object') {
                            checkoutCost = {
                                amount: ((_b = checkoutCostRaw.amount) === null || _b === void 0 ? void 0 : _b.toString()) ||
                                    ((_c = checkoutCostRaw.amountE2) === null || _c === void 0 ? void 0 : _c.toString()) ||
                                    '0',
                                currencyCode: checkoutCostRaw.currencyCode || 'USD',
                            };
                        }
                        else if (!!checkoutCostRaw &&
                            ['number', 'string'].includes(typeof checkoutCostRaw)) {
                            checkoutCost = {
                                amount: checkoutCostRaw.toString() || '0',
                                currencyCode: checkoutCostRaw.currencyCode || 'USD',
                            };
                        }
                    }
                }
                catch (ex) {
                    this.handleError(ex);
                }
                /** @todo kill hardcode */
                const isCheckoutCampaign = true || !!checkoutCost;
                const marketingOffer = {
                    title: slots === null || slots === void 0 ? void 0 : slots.title,
                    subtitle: slots === null || slots === void 0 ? void 0 : slots.subtitle,
                    callouts: slots === null || slots === void 0 ? void 0 : slots.callouts,
                    cardholderAgreement: agreements && agreements[agreements_1.AgreementKey.CardholderAgreement],
                    embeddedAdUrl: `${__classPrivateFieldGet(this, _SDKClient_instances, "m", _SDKClient_getBaseUrl).call(this, data)}/ecad/${isCheckoutCampaign ? 'checkout/d/' : 'custom-ui/'}${products_1.PRODUCT_SLUG_TO_ID[(productSlug !== null && productSlug !== void 0 ? productSlug : '')]}?utm_campaign=${utmCampaign}&amountE2=77225`,
                    ratesAndFees: agreements && agreements[agreements_1.AgreementKey.Schumer],
                    terms: {
                        id: campaignUuid,
                        title: 'Offer Terms' /** @todo support localization */,
                        html: slots === null || slots === void 0 ? void 0 : slots.termsHtml,
                        url: `${__classPrivateFieldGet(this, _SDKClient_instances, "m", _SDKClient_getBaseUrl).call(this, data)}/offer/terms/${productSlug}${utmCampaign ? `/${utmCampaign}` : ''}`,
                    },
                };
                return { marketingOffer };
            }
            catch (ex) {
                this.handleError(ex);
            }
        });
    }
    /**
     * Get Cardless user state for parther user state
     */
    getPartnerUserState(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { kid, partnerUserId } = data;
            if (!partnerUserId) {
                throw new Error('getPartnerUserState expected to find partnerUserId in SDKData, but found none');
            }
            if (!kid) {
                throw new Error('getPartnerUserState expected to find kid in SDKData, but found none');
            }
            const _a = yield __classPrivateFieldGet(this, _SDKClient_apiClient, "f").getPartnerUserState({
                kid,
                partnerUserId,
            }), { state } = _a, others = __rest(_a, ["state"]);
            const baseUrlParts = __classPrivateFieldGet(this, _SDKClient_instances, "m", _SDKClient_getBaseUrl).call(this, data).split('?');
            const baseUrl = baseUrlParts[0];
            const searchParamsSDK = __classPrivateFieldGet(this, _SDKClient_instances, "m", _SDKClient_getURLSearchParams).call(this, data, state).toString();
            const baseUrlSearch = baseUrlParts[1];
            const searchParams = [searchParamsSDK, baseUrlSearch]
                .filter(Boolean)
                .join('&');
            let context;
            if (state === user_1.PartnerUserState.NewUser &&
                (data.productSlug || data.brandSlug)) {
                context = yield this.fetchApplyContext(data);
            }
            const response = {
                state,
                context: Object.assign(Object.assign({}, context), { baseUrl: `${baseUrl}${__classPrivateFieldGet(this, _SDKClient_instances, "m", _SDKClient_getBasePathForUserState).call(this, state)}?${searchParams}` }),
                userUuid: 'userUuid' in others ? others.userUuid : undefined,
            };
            return response;
        });
    }
    /**
     * Fetch session identifier for the cardless API given the signed data
     *
     * @todo SDK will need to explicitly handle failure here, esp if encodedUserData needs to be regenerated... via onError handler, maybe?
     */
    loginViaPartner(_a) {
        return __awaiter(this, arguments, void 0, function* ({ encodedUserData, partnerUserId }) {
            if (!encodedUserData) {
                throw new Error('loginViaPartner invariant violation: expected to find encodedUserData in SDKData, but found none');
            }
            if (!partnerUserId) {
                throw new Error('loginViaPartner invariant violation: expected to find partnerUserId in SDKData, but found none');
            }
            const resp = yield __classPrivateFieldGet(this, _SDKClient_authClient, "f").loginViaPartner({
                partnerToken: encodedUserData,
                userId: partnerUserId,
            });
            __classPrivateFieldSet(this, _SDKClient_refreshToken, resp.refresh_token, "f");
            __classPrivateFieldGet(this, _SDKClient_apiClient, "f").setAccessToken(resp.access_token);
            return resp;
        });
    }
    /**
     * Report error events and exceptions
     */
    handleError(err) {
        if (process.env.CYPRESS_IS_RUNNING !== 'true') {
            import('@datadog/browser-rum')
                .then(({ datadogRum }) => {
                datadogRum.addError(err);
            })
                .catch(() => {
                console.error(LOG_TAG, err);
            });
        }
        else {
            console.error(LOG_TAG, err);
        }
    }
    /**
     * Communicate result of RPC call back up to SDK.
     * Note: public method for sake of ability to spy in test suites
     */
    handleRPCResult({ data, port, result, }) {
        console.log(LOG_TAG, data.kid, '<', JSON.stringify(result));
        port === null || port === void 0 ? void 0 : port.postMessage(JSON.stringify(result));
    }
    /**
     * Communicate RPC errors back up to SDK.
     * Note: public method for sake of ability to spy in test suites
     */
    handleRPCError({ data, error, port, }) {
        let message;
        if (error) {
            if (typeof error === 'string') {
                message = error;
            }
            else {
                if (this.env !== 'production' &&
                    error !== null &&
                    typeof error === 'object' &&
                    'response' in error &&
                    'data' in error.response) {
                    console.log(JSON.stringify(error)); // log API errors for quick debugging
                }
                message = (error === null || error === void 0 ? void 0 : error.message) ? error.message : error.toString();
            }
        }
        console.log(LOG_TAG, data === null || data === void 0 ? void 0 : data.kid, '< error:', message);
        port === null || port === void 0 ? void 0 : port.postMessage(JSON.stringify({ error: message }));
    }
    /**
     * Initializes two-day data flow of SDK input and output
     */
    acceptSDKData() {
        const messageListener = ((event) => {
            const boundHandleRPCResult = this.handleRPCResult.bind(this);
            const boundHandleRPCError = this.handleRPCError.bind(this);
            let port;
            let data;
            try {
                if (typeof event.data !== 'string')
                    return;
                /**
                 * this is (likely) a reference to the SDK!
                 * undefined when running standalone
                 */
                port = event.ports[0];
                /**
                 * try parsing event data
                 */
                try {
                    data = JSON.parse(event.data);
                }
                catch (ex) {
                    boundHandleRPCError({ data, error: ex, port });
                    data = undefined;
                }
                if (
                // an origin is defined (it's not in Android)
                event.origin &&
                    // origins do not match; ensure message is coming from a supported source
                    event.origin !== location.origin &&
                    ((this.env === 'production' &&
                        // only accept messages from Cardless in production
                        !/((app|app2|embedded|ecad|ads)\.cardless\.com)$/.test(event.origin)) ||
                        (this.env === 'staging' &&
                            // only accept messages from Cardless, Cardless preview URLs, and localhost in staging
                            !/((app|app2|embedded|ecad|ads)(-beta)?\.cardless(-staging)?\.com|-cardless-team\.vercel\.app|localhost:\d{2,4}|127\.0\.0\.1:\d{2,4})$/.test(event.origin)))) {
                    console.log(LOG_TAG, 'ignoring message from origin', event.origin);
                    return;
                }
                // bounce early when we don't have information to work with
                if (data === undefined) {
                    return;
                }
                // bounce early for non-Cardless post messages (e.g. Plaid, etc)
                if (!data.rpc && !data.kid) {
                    return;
                }
                console.log(LOG_TAG, data.kid, '>', data.rpc);
                // this could illustrate how the SDK can call methods of the client programatically!
                const rpc = data.rpc ? this[data.rpc].bind(this) : undefined;
                if (typeof rpc !== 'function')
                    return;
                rpc(data)
                    .then((result) => {
                    boundHandleRPCResult({ data: data, port, result });
                })
                    .catch((error) => {
                    boundHandleRPCError({ data, error, port });
                });
            }
            catch (ex) {
                boundHandleRPCError({ data, error: ex, port });
            }
        }).bind(this);
        self.addEventListener('message', messageListener);
        const notification = new SDKNotification({
            eventName: SDKEvent.Ready,
        });
        this.notify({
            source: CHQ_SDK_ID,
            notification,
        });
        console.log(LOG_TAG, `accepting messages: env=${this.env} CardlessSDK?=${!!(self === null || self === void 0 ? void 0 : self.CardlessSDK)}`);
    }
    addAuthListener(listener) {
        __classPrivateFieldGet(this, _SDKClient_authListeners, "f").push(listener);
    }
    removeAuthListener(listener) {
        const index = __classPrivateFieldGet(this, _SDKClient_authListeners, "f").indexOf(listener);
        __classPrivateFieldGet(this, _SDKClient_authListeners, "f").splice(index, 1);
    }
}
exports.SDKClient = SDKClient;
_SDKClient_apiClient = new WeakMap(), _SDKClient_authClient = new WeakMap(), _SDKClient_authListeners = new WeakMap(), _SDKClient_refreshToken = new WeakMap(), _SDKClient_instances = new WeakSet(), _SDKClient_refreshAccessTokenMiddleware = function _SDKClient_refreshAccessTokenMiddleware() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const { access_token, refresh_token } = yield __classPrivateFieldGet(this, _SDKClient_authClient, "f").refreshAccessToken((_a = __classPrivateFieldGet(this, _SDKClient_refreshToken, "f")) !== null && _a !== void 0 ? _a : '');
        __classPrivateFieldSet(this, _SDKClient_refreshToken, refresh_token, "f");
        return access_token;
    });
}, _SDKClient_fetchApplicationAgreements = function _SDKClient_fetchApplicationAgreements(data) {
    return __awaiter(this, void 0, void 0, function* () {
        const { clientIpAddress, productSlug } = data;
        if (!productSlug) {
            throw new Error('fetchApplicationAgreements expected to find productSlug in SDKData, but found none');
        }
        try {
            const agreementsData = yield __classPrivateFieldGet(this, _SDKClient_apiClient, "f").getApplicationAgreements({
                clientIpAddress,
                productSlug,
            });
            const basicAgreements = agreementsData.agreements.reduce((coll, agreement) => {
                const { agreementKey, name, url } = agreement;
                const basicAgreement = {
                    id: agreementKey,
                    title: name,
                    pdfUrl: url,
                    url,
                };
                coll[agreementKey] = basicAgreement;
                return coll;
            }, {});
            const schumerAgreement = basicAgreements[agreements_1.AgreementKey.Schumer];
            if (schumerAgreement) {
                schumerAgreement.url = `${__classPrivateFieldGet(this, _SDKClient_instances, "m", _SDKClient_getBaseUrl).call(this, data)}/offer/rates-and-fees/${productSlug}`;
                /**
                 * Don't blow this up should fetching rates & fees JSON fail.
                 * Why? We're still returning the PDF URL, which is a decent fallback
                 */
                try {
                    const premium = (0, agreements_1.getPremiumFromAgreementUrl)(schumerAgreement === null || schumerAgreement === void 0 ? void 0 : schumerAgreement.pdfUrl);
                    const ratesAndFeesJsonUrl = (0, agreements_1.getRatesAndFeesJsonUrl)({
                        env: this.env,
                        premium,
                    });
                    const ratesAndFeesJsonResponse = yield fetch(ratesAndFeesJsonUrl);
                    if (ratesAndFeesJsonResponse.ok) {
                        const ratesAndFeesJson = yield ratesAndFeesJsonResponse.json();
                        if (ratesAndFeesJson) {
                            schumerAgreement.json = ratesAndFeesJson;
                        }
                    }
                }
                catch (ex) {
                    this.handleError(ex);
                }
            }
            return basicAgreements;
        }
        catch (ex) {
            this.handleError(ex);
        }
    });
}, _SDKClient_getBaseUrl = function _SDKClient_getBaseUrl({ webappBaseURL }) {
    if (webappBaseURL) {
        return webappBaseURL;
    }
    else if (this.env === 'staging') {
        return constants_1.WEBAPP_BASE_URL_STAGING;
    }
    else {
        return constants_1.WEBAPP_BASE_URL_PRODUCTION;
    }
}, _SDKClient_getBasePathForUserState = function _SDKClient_getBasePathForUserState(userState) {
    if (userState === user_1.PartnerUserState.Active) {
        return '/account/m';
    }
    else {
        return '/apply';
    }
}, _SDKClient_getURLSearchParams = function _SDKClient_getURLSearchParams({ campaignSlug, kid, partnerUserId, productSlug, sessionId }, state) {
    const searchParams = {
        kid: kid !== null && kid !== void 0 ? kid : '',
        state,
        product: productSlug !== null && productSlug !== void 0 ? productSlug : '',
        campaign: campaignSlug !== null && campaignSlug !== void 0 ? campaignSlug : '',
        session: sessionId !== null && sessionId !== void 0 ? sessionId : '',
        user: partnerUserId !== null && partnerUserId !== void 0 ? partnerUserId : '',
    };
    return new URLSearchParams(searchParams);
};
